import { render } from "./CondominiumComponentSearch.vue?vue&type=template&id=6787908e&scoped=true"
import script from "./CondominiumComponentSearch.vue?vue&type=script&lang=js"
export * from "./CondominiumComponentSearch.vue?vue&type=script&lang=js"

import "./CondominiumComponentSearch.vue?vue&type=style&index=0&id=6787908e&scoped=true&lang=css"

import exportComponent from "C:\\frotend\\d7m_front_sindico\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6787908e"]])

export default __exports__